import { cabecalhoHistoricoStyles } from './CabecalhoHistorico.style'
import { CabecalhoHistoricoProps } from './CabecalhoHistorico.View'
import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import { Parceiro } from '../../../../types/parceiroApiTypes'
import parceiroManager from '../../../../services/api/parceiro/parceiroManager'
import { useForm } from 'react-hook-form'

export function cabecalhoHistoricoIO({ handleClickParceiro, setMesesSelecionado }: CabecalhoHistoricoProps) {
  const [abrirModalFiltroParceiros, setAbrirModalFiltroParceiros] = useState(false)
  const [parceiros, setParceiros] = useState<Parceiro[]>([])

  const { control, watch } = useForm<{ meses: 1 | 6 | 12 }>({
    defaultValues: {
      meses: 6
    }
  })

  useEffect(() => {
    obterParceirosAtivos()
  }, [])

  const obterParceirosAtivos = useCallback(async () => {
    await parceiroManager
      .buscarDadosParceiros(true)
      .then((response: Parceiro[]) => {
        setParceiros(response)
      })
      .catch(() => {
        toast.error(msgConstants.USO_GENERICO.erroBusca)
      })
  }, [])

  function handleFecharChip() {
    handleClickParceiro(0)
  }

  const dropDownMes = watch('meses')

  useEffect(() => {
    setMesesSelecionado(dropDownMes)
  }, [dropDownMes])

  return {
    styles: cabecalhoHistoricoStyles,
    abrirModalFiltroParceiros,
    setAbrirModalFiltroParceiros,
    parceiros,
    handleFecharChip,
    control
  }
}

export type CabecalhoHistoricoIO = ReturnType<typeof cabecalhoHistoricoIO>
